module.exports = __webpack_public_path__ + "img/Globe_UV Map_Displacement Map.e2455a43.png";